import React, { useState } from "react";
import {
  FaWallet, FaShoppingCart, FaLock, FaUserShield, FaMoneyBillWave,
  FaUserFriends, FaHistory, FaExchangeAlt, FaDollarSign, FaEuroSign,
  FaVoteYea, FaCrown, FaTachometerAlt, FaAddressCard, FaGem,
  FaHandHoldingUsd, FaChevronDown
} from "react-icons/fa";

const Sidebar = ({ setActiveSection, activeSection }) => {
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (category) => {
    setOpenDropdown(openDropdown === category ? null : category);
  };

  const handleNavClick = (section) => {
    setActiveSection(section);
  };

  const menuCategories = {
    dashboard: {
      label: "Dashboard",
      icon: <FaTachometerAlt />,
      items: [
        { id: "dashboard", label: "Dashboard", icon: <FaTachometerAlt /> },
        { id: "overview", label: "Overview", icon: <FaWallet /> },
        { id: "myAccount", label: "My Account", icon: <FaCrown />, className: "governance" },
      ]
    },
    defi: {
      label: "DeFi",
      icon: <FaGem />,
      items: [
        { id: "crowndex", label: "CrownDex", icon: <FaGem />, className: "crowndex" },
        { id: "lending", label: "Lending", icon: <FaHandHoldingUsd /> },
        { id: "stake", label: "Stake", icon: <FaLock /> },
        { id: "loans", label: "Loans", icon: <FaMoneyBillWave /> },
        { id: "userLoans", label: "User Loans", icon: <FaUserFriends /> },
        { id: "p2p", label: "P2P Trading", icon: <FaExchangeAlt /> },
      ]
    },
    tokens: {
      label: "Tokens",
      icon: <FaDollarSign />,
      items: [
        { id: "buySell", label: "Buy/Sell CRW", icon: <FaShoppingCart /> },
        { id: "cusd", label: "CUSD", icon: <FaDollarSign />, className: "cusd" },
        { id: "deus", label: "DEUS", icon: <FaEuroSign />, className: "deus" },
        { id: "transfer", label: "Transfer", icon: <FaExchangeAlt /> },
      ]
    },
    governance: {
      label: "Governance",
      icon: <FaVoteYea />,
      items: [
        { id: "governance", label: "Governance DAO", icon: <FaVoteYea />, className: "governance" },
        { id: "validators", label: "Validators", icon: <FaUserShield /> },
      ]
    },
    tools: {
      label: "Tools",
      icon: <FaHistory />,
      items: [
        { id: "transactions", label: "Transactions", icon: <FaHistory /> },
        { id: "addressContract", label: "Contracts", icon: <FaAddressCard /> },
      ]
    }
  };

  return (
    <nav className="top-navigation">
      <div className="nav-container">
        {Object.entries(menuCategories).map(([key, category]) => (
          <div
            key={key}
            className={`nav-category ${openDropdown === key ? 'active' : ''}`}
            onMouseEnter={() => setOpenDropdown(key)}
            onMouseLeave={() => setOpenDropdown(null)}
          >
            <button className="nav-category-btn">
              {category.icon}
              <span>{category.label}</span>
              <FaChevronDown className="dropdown-icon" />
            </button>
            <div className={`nav-dropdown ${openDropdown === key ? 'show' : ''}`}>
              {category.items.map((item) => (
                <button
                  key={item.id}
                  onClick={() => handleNavClick(item.id)}
                  className={`nav-item ${item.className || ''} ${activeSection === item.id ? 'active' : ''}`}
                >
                  {item.icon}
                  <span>{item.label}</span>
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </nav>
  );
};

export default Sidebar;